(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9689],{

/***/ 60891:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/[id]",
      function () {
        return __webpack_require__(16253);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_GlobalLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./blocks/DialoguePresenter/DialoguePresenter.tsx
var DialoguePresenter = __webpack_require__(38114);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./components/NavigationItem/NavigationItem.tsx
var NavigationItem = __webpack_require__(10493);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsIcon.tsx
var LittleEmperorsIcon = __webpack_require__(21965);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./customHooks/useSignIn/useSignIn.ts
var useSignIn = __webpack_require__(37394);
// EXTERNAL MODULE: ./utils/memberAppSignInRedirect.ts
var memberAppSignInRedirect = __webpack_require__(37918);
// EXTERNAL MODULE: ./components/icons/BurgerMenuIcon.tsx
var BurgerMenuIcon = __webpack_require__(61063);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsTextIcon.tsx
var LittleEmperorsTextIcon = __webpack_require__(15096);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
;// CONCATENATED MODULE: ./components/icons/BurgerMenuCloseIcon.tsx

var BurgerMenuCloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#A)",
                "fill-rule": "evenodd",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.497 3.493a.5.5 0 0 1 .707 0l16.305 16.305a.5.5 0 0 1-.707.707L3.497 4.2a.5.5 0 0 1 0-.707z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.502 3.491a.5.5 0 0 1 0 .707L4.198 20.503a.5.5 0 1 1-.707-.707L19.795 3.491a.5.5 0 0 1 .707 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "A",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_BurgerMenuCloseIcon = (BurgerMenuCloseIcon);

// EXTERNAL MODULE: ./customHooks/useAuth/AuthProvider.tsx + 1 modules
var AuthProvider = __webpack_require__(52961);
;// CONCATENATED MODULE: ./blocks/Header/Header.tsx




















var Header = function() {
    var router = (0,next_router.useRouter)();
    var join_us_text = (0,useLocalised/* default */.Z)(translationKeys.join_us);
    var sign_in_text = (0,useLocalised/* default */.Z)(translationKeys.sign_in);
    var ref = (0,react.useContext)(useSignIn/* SignInContext */.f), setSignInState = ref.setState;
    var ref1 = (0,react.useContext)(useDialogue/* DialogueContext */.$), openDialogue = ref1.openDialogue, closeDialogue = ref1.closeDialogue, dialogueState = ref1.dialogueState;
    var isMobileMenuOpen = dialogueState.presentedDialogueType === constants/* MOBILE_MENU_DIALOGUE */.uN;
    var handleClickOnSignIn = (0,react.useCallback)(function() {
        var hotelRedirect = (0,memberAppSignInRedirect/* getHotelMemberSignInRedirectFromRouter */.e)(router.pathname, router.query);
        setSignInState(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                redirectTo: hotelRedirect
            });
        });
        openDialogue(constants/* SIGN_IN_DIALOG */.jt);
    }, [
        openDialogue,
        router.pathname,
        router.query,
        setSignInState
    ]);
    var handleClickOnJoinUs = (0,react.useCallback)(function() {
        openDialogue(constants/* JOIN_US_DIALOG_STEP_1 */.le);
    }, [
        openDialogue
    ]);
    var handleBurgerMenuClick = (0,react.useCallback)(function() {
        openDialogue(constants/* MOBILE_MENU_DIALOGUE */.uN);
    }, [
        openDialogue
    ]);
    var signedIn = (0,AuthProvider/* useAuth */.a)().signedIn;
    var homePage = signedIn ? constants/* navigationPaths.WEB_APP_HOMEPAGE */.aY.WEB_APP_HOMEPAGE : constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "header-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-component__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Hotels",
                            path: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Membership",
                            path: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Gift cards",
                            path: constants/* navigationPaths.E_GIFT_CARD */.aY.E_GIFT_CARD,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "MyLER",
                            path: constants/* navigationPaths.INDEPENDENT_TRAVEL_AGENT */.aY.INDEPENDENT_TRAVEL_AGENT,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Journal",
                            path: constants/* navigationPaths.TRAVEL_JOURNAL_ARTICLES */.aY.TRAVEL_JOURNAL_ARTICLES,
                            className: "header-navigation-item"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "burger-icon",
                    children: [
                        !isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleBurgerMenuClick,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenuIcon/* default */.Z, {})
                        }),
                        isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeDialogue,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BurgerMenuCloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            className: "header-text-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsTextIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-rigth",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: join_us_text,
                            onClick: handleClickOnJoinUs,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-join_us_text_button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: sign_in_text,
                            onClick: handleClickOnSignIn,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-navigation-item"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ./blocks/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(53114);
;// CONCATENATED MODULE: ./utils/header.ts
function formatCanonicalUrl(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return url;
    }
    return url.replace(/^https?:\/\/(www\.)?/, "https://");
}
// gets first sentence or two from some copy
function getDescriptionFromContent(text) {
    if (!text) {
        return "";
    }
    var sentences = text.match(/[^.!?]+[.!?](?=\s+|$)/g);
    if (!sentences) {
        return text;
    }
    // help avoid splitting on common abbreviations  
    var abbreviations = /\b(?:[A-Z]\.|(?:[A-Z]\w{0,2}\.){2,}|e\.g\.|i\.e\.)/i;
    var combinedText = sentences[0].trim();
    // sensible minimum length for description
    if (combinedText.length > 90) {
        return combinedText;
    }
    for(var i = 1; i < sentences.length; i++){
        if (abbreviations.test(sentences[i])) {
            combinedText += " " + sentences[i].trim();
            continue;
        }
        combinedText += " " + sentences[i].trim();
        if (combinedText.length > 90) {
            return combinedText;
        }
    }
    return text;
}

;// CONCATENATED MODULE: ./blocks/Layouts/GlobalLayout.tsx



//Components



var GlobalLayout = function(param) {
    var children = param.children, memberships = param.memberships, currencies = param.currencies, countryCodes = param.countryCodes, metaData = param.metaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Little Emperors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaData.url
                    }),
                    metaData.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: metaData.type
                    }),
                    metaData.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaData.image
                    }),
                    metaData.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: metaData.author
                    }),
                    metaData.publishedTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: metaData.publishedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: formatCanonicalUrl(metaData.url)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-content-container",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialoguePresenter/* default */.Z, {
                memberships: memberships,
                currencies: currencies,
                countryCodes: countryCodes
            })
        ]
    });
};
/* harmony default export */ var Layouts_GlobalLayout = (GlobalLayout);


/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ FILLED_BUTTON_TYPE_DARK; },
/* harmony export */   "II": function() { return /* binding */ LINK_BUTTON_TYPE; },
/* harmony export */   "ME": function() { return /* binding */ FILLED_BUTTON_TYPE; },
/* harmony export */   "Wr": function() { return /* binding */ OUTLINED_BUTTON_TYPE_DARK; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95475);



var LINK_BUTTON_TYPE = "LINK_BUTTON_TYPE";
var FILLED_BUTTON_TYPE = "FILLED_BUTTON_TYPE";
var FILLED_BUTTON_TYPE_DARK = "FILLED_BUTTON_TYPE_DARK";
var OUTLINED_BUTTON_TYPE_DARK = "OUTLINED_BUTTON_TYPE_DARK";
var Button = function(param) {
    var title = param.title, onClick = param.onClick, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? FILLED_BUTTON_TYPE : _buttonType, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, className = param.className, htmlAttributes = param.htmlAttributes;
    var handleOnClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (isLoading) {
            return;
        }
        onClick();
    }, [
        isLoading,
        onClick
    ]);
    var getClass = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var classNameArray = [];
        var inititalClassName = "button-body-filled";
        switch(buttonType){
            case LINK_BUTTON_TYPE:
                inititalClassName = "button-body-link";
                break;
            case FILLED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-filled-dark";
                break;
            case OUTLINED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-outlined-dark";
            default:
                break;
        }
        classNameArray.push(inititalClassName);
        if (className) {
            classNameArray.push(className);
        }
        return classNameArray.join(" ");
    }, [
        buttonType,
        className
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.type,
        onClick: handleOnClick,
        className: getClass(),
        "area-label": title,
        style: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.style,
        disabled: (htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.disabled) || false,
        children: [
            !isLoading && title,
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 16253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var services_DateService_DateService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57838);
/* harmony import */ var blocks_Layouts_GlobalLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94082);





var PressDetail = function(param) {
    var globalLayoutProps = param.globalLayoutProps, _pressElement = param.pressElement, newsMediaTitle = _pressElement.newsMediaTitle, title = _pressElement.title, date = _pressElement.date, content = _pressElement.content, pdfMedia = _pressElement.pdfMedia;
    if (pdfMedia && pdfMedia.length > 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(blocks_Layouts_GlobalLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, globalLayoutProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "scanned-media-page",
                children: pdfMedia && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "scanned-media-page__container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "article-title",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "title",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "date",
                                        children: services_DateService_DateService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getFormattedDateString */ .Z.getFormattedDateString(date)
                                    })
                                ]
                            }),
                            pdfMedia.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "article-pdf",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                        className: "article-pdf__frame",
                                        title: title,
                                        frameBorder: "0",
                                        src: "https://docs.google.com/gview?url=".concat(item, "&embedded=true")
                                    })
                                }, item);
                            })
                        ]
                    })
                })
            })
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(blocks_Layouts_GlobalLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "press-detail",
            children: [
                newsMediaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "press-detail__news-media-title",
                    children: newsMediaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "press-detail__title",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "press-detail__date",
                    children: services_DateService_DateService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getFormattedDateString */ .Z.getFormattedDateString(date)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "press-detail__content-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "content-box",
                        children: content
                    })
                })
            ]
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PressDetail);


/***/ }),

/***/ 37918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getHotelMemberSignInRedirectFromRouter; }
/* harmony export */ });
/**
 * When the user opens sign-in from a public hotel page, the member webapp expects
 * external-login?redirect=hotel/{numericId} (path after /ile/, no leading slash).
 */ function getHotelMemberSignInRedirectFromRouter(pathname, query) {
    if (pathname !== "/our-hotels/[idHotel]") {
        return undefined;
    }
    var raw = query.idHotel;
    var id = Array.isArray(raw) ? raw[0] : raw;
    if (typeof id !== "string" || !/^\d+$/.test(id)) {
        return undefined;
    }
    return "hotel/".concat(id);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,4520,9774,2888,179], function() { return __webpack_exec__(60891); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);